export default "__VITE_ASSET__DZab5plp__"